import { GameState } from "./game-state";
import { Ball } from "./ball";
import { HitResultEnum } from "../types/hit-result-enum";
import { Game } from "./game";
import { BallTypeEnum } from "../types/ball-type-enum";
import { GameConfig } from "../config/game-config";
import { IAssetsConfig } from "../types/game-config-type";
import gameApplication from "./game-app";
import { BallsFactory } from "./balls-factory";
import { store } from "../stores";
import { MutationType } from "../stores/mutation-types";
import { Player } from "./player";
import { Vector2 } from "../math/vector2";

const sounds: IAssetsConfig = GameConfig.sounds;

enum TableState {
    Opened, Closed
}
export class Game8PoolUK extends Game {

  private yellowIcon: string = 'yellow.svg';
	private redIcon: string = 'red.svg';
	private blackIcon: string = 'black.svg';
  private unknownIcon: string = 'default-pool-uk.svg';

  private eightBall: Ball;

  private breakShotFlag: boolean;
	private freeShotFlag: boolean;
  private extraShotFlag: boolean;
  
  private state: TableState;

  constructor() {
    super();
    this.initGame();
  }
  
  /**
   * This initilises the game. 
   */
  public initGame(): void {
    this.state = TableState.Opened;

    this.breakShotFlag = true;
    this.freeShotFlag = false;
    this.extraShotFlag = false;

    this.rackBalls();

    // initilise the game state
    this.gameState = new GameState();
    this.gameState.setupCueBall = true;

    // start the game play
    this.startGame();
  }

  private rackBalls(): void {
    this.gameBalls = BallsFactory.createPool8UKBalls();
    this.cueBall = this.gameBalls[0];
    this.eightBall = this.gameBalls[8];
  }

  protected processEvents(): HitResultEnum {
    // Check if black 8 ball is potted.
    if (!this.eightBall.onTable && this.cueBall.onTable) {
      if (this.currentTurnPlayer.ballType !== BallTypeEnum.Eight) {
        // if player scratched black 8 ball before other balls from own group
        if (this.breakShotFlag) {
          store.commit(MutationType.GAME_MESSAGE,`RESULT: 8 Ball ${gameApplication.gameItem.gameType} - ${this.currentTurnPlayer.playerId} wins to ${this.nextTurnPlayer.playerId} - GOLDEN BREAK.`);
          return HitResultEnum.WIN_GAME_GOLDEN_BREAK;
        }
        else {
          let n: number = (this.currentTurnPlayerIndex == 0 ? 1 : 0);
          store.commit(MutationType.GAME_MESSAGE, `RESULT: 8 Ball ${gameApplication.gameItem.gameType} - ${this.currentTurnPlayer.playerId} loses to ${this.nextTurnPlayer.playerId} by a foul on the black.`);
          return HitResultEnum.LOST_GAME;
        }
      }
      else {
        // see if all of the opponents balls are on the table
        let ballCount: number = 0;

        for (let i: number = 1; i <= 15; i++) {
          const b: Ball = this.balls[i];
          if (b.onTable) {
            // the ball is not the cue ball
            if (b.type !== BallTypeEnum.Cue) {
              ballCount++;
            }
          }
        }

        // all of the opponents balls are on the table
        if (ballCount == 7) {
          store.commit(MutationType.GAME_MESSAGE, `RESULT: 8 Ball ${gameApplication.gameItem.gameType} - ${this.currentTurnPlayer.playerId} wins to ${this.nextTurnPlayer.playerId} - SEVEN BALLING.`);
          return HitResultEnum.WIN_GAME_SEVEN_BALLING;
        }

        store.commit(MutationType.GAME_MESSAGE, `RESULT: 8 Ball ${gameApplication.gameItem.gameType} - ${this.currentTurnPlayer.playerId} wins to ${this.nextTurnPlayer.playerId}.`);
        return HitResultEnum.WIN_GAME;
      }
    }

    // check if cue ball is potted
    if (!this.cueBall.onTable) {
      if (this.eightBall.onTable) {
        if (this.state == TableState.Closed) { // the table is closed
          this.isFoul = true; // opponent can set cue ball position
          this.freeShotFlag = true; // the next player has a free shot 
          this.extraShotFlag = false;
					store.commit(MutationType.GAME_MESSAGE, `Player ${this.currentTurnPlayer.playerId} scratched cue ball (foul). Player ${this.nextTurnPlayer.playerId} has two shots, the first shot is a free shot (can hit any ball).`);
					return HitResultEnum.PLAYER_CHANGE;
				}
        else { // the table is open
					// if the table is open first check if any balls have been pocketed
					// and the table needs to be closed
          if (this.gameState.pocketedBalls.length > 0) {
						// see if all of the potted balls are solids
            let allSolid: boolean = true;
            for (let b of this.gameState.pocketedBalls) {
              if (b.type != BallTypeEnum.Cue) {
								if (b.type == BallTypeEnum.Stripe) {
									allSolid = false;
								}
							}
            }
              
						// see if all of the potted balls are stripes
						let allStripes: boolean = true;
						for (let b of this.gameState.pocketedBalls) {
							if (b.type != BallTypeEnum.Cue) {
								if (b.type == BallTypeEnum.Solid) {
									allStripes = false;
								}
							}
						}

						if (!allSolid && !allStripes) {
							// both are potted
							store.commit(MutationType.GAME_MESSAGE, `Player ${this.currentTurnPlayer.playerId} potted both colors, table is still open.`);
						}
						else if (allSolid && allStripes) {
							// this means no colours have been potted only the cue ball do nothing
						}
						else {
							// one colour potted
							this.closeTable(this.gameState.pocketedBalls[0].type);
						}

            this.isFoul = true; // opponent can set cue ball position
            this.freeShotFlag = true; // the next player has a free shot
            this.extraShotFlag = false;
            store.commit(MutationType.GAME_MESSAGE, `Player ${this.currentTurnPlayer.playerId} scratched cue ball (foul). Player ${this.nextTurnPlayer.playerId} has two shots, the first shot is a free shot (can hit any ball).`); 
						return HitResultEnum.PLAYER_CHANGE;
					}
				}
      }
      else {
        // Player loose by illegally pocketing the cue ball - game over
        store.commit(MutationType.GAME_MESSAGE, `RESULT: 8 Ball ${this.currentTurnPlayer.playerId} - ${this.currentTurnPlayer.playerId} loses to ${this.nextTurnPlayer.playerId} by scratching cue ball with black ball.`);
        let n: number = (this.currentTurnPlayerIndex == 0 ? 1 : 0);
        return HitResultEnum.LOST_GAME;
      }
    }

    if (!this.gameState.ballBallCollision) {
      this.freeShotFlag = true; // the next player has a free shot 
      store.commit(MutationType.GAME_MESSAGE, `Player ${this.currentTurnPlayer.playerId} hit no ball (foul). Player ${this.nextTurnPlayer.playerId} has two shots, the first shot is a free shot (can hit any ball).`);
      return HitResultEnum.PLAYER_CHANGE;
    }

    if (this.state == TableState.Opened) {
      if (this.gameState.pocketedBalls.length > 0) {
				// see if any of the potted balls are stripes
				let allSolid: boolean = true;
				for (let b of this.gameState.pocketedBalls) {
					if (b.type == BallTypeEnum.Stripe) {
						allSolid = false;
					}
        }
        
				// see if any of the potted balls are solids
				let allStripes: boolean = true;
				for (let b of this.gameState.pocketedBalls) {
					if (b.type == BallTypeEnum.Solid) {
						allStripes = false;
					}
				}

				if (!allSolid && !allStripes) {
					// both ball types are potted
					store.commit(MutationType.GAME_MESSAGE, `Player ${this.currentTurnPlayer.playerId} potted both colors, table is still open.`);
					return HitResultEnum.OK;
				}
				else {
					// one ball type is potted
				  this.closeTable(this.gameState.pocketedBalls[0].type);
					return HitResultEnum.OK;
				}
			}

      if (!this.freeShotFlag) {
        this.extraShotFlag = false;
        return HitResultEnum.PLAYER_CHANGE;
      } 

      // table is open with a free shot
      this.extraShotFlag = false;
      this.freeShotFlag = false;
      return HitResultEnum.OK;
       
    }
    else { // the table is closed
      // If either player has no balls on the table then the player in on the 8 ball. 
      this.checkIfPlayerHasBalls(this.currentTurnPlayer);
      this.checkIfPlayerHasBalls(this.nextTurnPlayer);

      // check if cue ball had contact with own ball first
      const playerBallType: BallTypeEnum = this.currentTurnPlayer.ballType;

			if (!this.freeShotFlag) {
				// check if cue ball had contact with its own ball type first
			  if (this.gameState.firstCollidedBall.type !== playerBallType) {
          this.freeShotFlag = true; // the next player has a free shot
          store.commit(MutationType.GAME_MESSAGE, `${this.currentTurnPlayer.playerId} hit wrong ball (foul). ${this.nextTurnPlayer.playerId} has two shots, the first shot is a free shot (can hit any ball).`);
          this.extraShotFlag = false;
					return HitResultEnum.PLAYER_CHANGE;
				}

        for (const b of this.gameState.pocketedBalls) {
          if (b.type !== playerBallType) {
            this.freeShotFlag = true;
            store.commit(MutationType.GAME_MESSAGE, `${this.currentTurnPlayer.playerId} potted wrong ball (foul). ${this.nextTurnPlayer.playerId} has two shots, the first shot is a free shot (can hit any ball).`);
            this.extraShotFlag = false;
						return HitResultEnum.PLAYER_CHANGE;
					}
				}
      }

      // Determine if the player has potted balls and they are all legal.
      let isLegalPottedBalls: boolean = true;
      if (this.gameState.pocketedBalls.length === 0) {
        isLegalPottedBalls = false;
      } else {
        for (const b of this.gameState.pocketedBalls) {
          if (b.type !== playerBallType) {
            isLegalPottedBalls = false;
            break;
          }
        }
      }

      // This must be legal potted balls
			if (isLegalPottedBalls || this.freeShotFlag || this.extraShotFlag) {
        if ((isLegalPottedBalls && this.freeShotFlag) || (isLegalPottedBalls && this.extraShotFlag)) {
          this.extraShotFlag = true; // the current player gets or maintains an extra shot
				}
				else if (this.extraShotFlag) {
					this.extraShotFlag = false;
				}
        
        this.freeShotFlag = false;

        // These must be legal poketed balls.
        if (isLegalPottedBalls) {
          store.commit(MutationType.GAME_MESSAGE, `${this.currentTurnPlayer.playerId} potted ball and gets an extra shot.`);
        }

				return HitResultEnum.OK;
			}

      this.freeShotFlag = false;
			return HitResultEnum.PLAYER_CHANGE;
    }
  }

  private checkIfPlayerHasBalls(p: Player): void {
    const playerBallType: BallTypeEnum = p.ballType;

    if (playerBallType !== BallTypeEnum.Eight) {
      const sx: number = playerBallType == BallTypeEnum.Solid ? 1 : 9;
      let change: boolean = true;
      for (let i: number = sx; i < sx + 7; i++) {
        let b: Ball = this.balls[i];
        if (b.onTable) {
          change = false;
          break;
        }
      }
      if (change) {
        this.setPlayerBallType(p, BallTypeEnum.Eight);
      }
    }
  }
 
  private setPlayerBallType(p: Player, ballType: BallTypeEnum): void {
    let icon: string = '';

    switch (ballType) {
      case BallTypeEnum.Solid:
        icon = this.redIcon;
        break;
      case BallTypeEnum.Stripe:
        icon = this.yellowIcon;
        break;
      case BallTypeEnum.Eight:
        icon = this.blackIcon;
        break;
      default:
        break;
    }

    p.ballType = ballType;
    p.player.ball = icon;
  }
  
  private closeTable(ballType: BallTypeEnum): void {
    this.setPlayerBallType(this.currentTurnPlayer, ballType);
    this.setPlayerBallType(this.nextTurnPlayer, ballType == BallTypeEnum.Solid ? BallTypeEnum.Stripe : BallTypeEnum.Solid);
    this.state = TableState.Closed;
    store.commit(MutationType.GAME_MESSAGE, `The table is closed.`);
  }

  /**
   * Validate the position of the cue ball on the table.
   * 
   * @param position - the position of the cue ball
	 * @returns Retruns "true" if the cue ball postion is valid and "false" of not
   */
  public validateCueBallPosition(position: Vector2): boolean  {
    if (position.x > Game.BAULK_LINE_POS) {
			return false;
		}
    return true;
	}

  /**
   * This handles the change the of the current player if necessary.
   */
  public continueGame(): void {
  
    if (this.breakShotFlag &&
      this.currentTurnPlayer.player !== undefined &&
      this.hitResult === undefined) {
      this.currentTurnPlayer.player.ball = 'default-pool-uk.svg';
      this.nextTurnPlayer.player.ball = 'default-pool-uk.svg';
    }
   
    switch (this.hitResult) {
      case HitResultEnum.PLAYER_CHANGE:
        this.currentPlayerIndex = (this.currentPlayerIndex + 1) % this.players.length;

        // Store the player change in the Vuex store.
        store.commit(MutationType.PLAY_TURN, this.players[this.currentPlayerIndex].playerId);

        // Emit the "player change" event to the Vue.js front end.
        gameApplication.fireEvent('PLAYER_CHANGE');

        break;
      case HitResultEnum.OK:
        // Store the current player in the Vuex store.
        // I think here there is no change in the player turn so this is not needed.
        store.commit(MutationType.PLAY_TURN, this.players[this.currentPlayerIndex].playerId);

        // Emit the "Okay" event to the Vue.js front end.
        gameApplication.fireEvent('OK');

        break;
    }

    // Store the players updated player details in the Vuex.
    // This this updates the status of the payers in the front end.
    store.commit(MutationType.PLAYER1, this.players[0]);
    store.commit(MutationType.PLAYER2, this.players[1]);

    this.breakShotFlag = false;
  }
}
